<div class="c-container c-banner__container">
	<div class="c-banner__title-container">
		<h1 class="c-banner__title">
			{{ title }}
		</h1>
	</div>
</div>
